import { useCallback } from 'react';

import { SegmentedButton } from '@frontierag/frontier-ui-library';
import { useField } from 'formik';

import type { SegmentedButtonField } from './types';

export default function SegmentedButtonField({
  name,
  segments,
  onChange,
  sx,
}: SegmentedButtonField) {
  const [{ value }, , { setValue }] = useField(name);

  const handleChange = useCallback(
    async (e, value) => {
      if (value !== null) {
        await setValue(value, true);
        if (onChange) onChange(value);
      }
    },
    [setValue, onChange],
  );

  return (
    <SegmentedButton
      data-testid={`segmented-button-field-${name}`}
      selectedValue={value}
      segments={segments}
      onChange={handleChange}
      sx={sx}
    />
  );
}
